import RolesService from '@/services/roles.service'

const state = {
  items: [],
  permissions: [],
  pagination: {
    page: 1,
    perPage: 15,
    total: 0,
    lastPage: 1,
  },
  currentItem: null,
  loading: false,
  error: null,
}

const getters = {
  items: (state) => state.items || [],
  permissions: (state) => state.permissions || [],
  pagination: (state) => state.pagination,
  currentItem: (state) => state.currentItem,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = Array.isArray(items) ? items : []
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = Array.isArray(permissions) ? permissions : []
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = {
      page: pagination.current_page || pagination.page || 1,
      perPage: pagination.per_page || pagination.perPage || 15,
      total: pagination.total || 0,
      lastPage: pagination.last_page || pagination.lastPage || 1,
    }
  },
  SET_CURRENT_ITEM(state, item) {
    state.currentItem = item
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  },
}

const actions = {
  async fetchAll({ commit }, params = {}) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await RolesService.getAll({
        page: params.page || 1,
        per_page: params.perPage || 15,
      })
      
      // Handle Laravel pagination response
      let items = []
      let pagination = {}
      
      if (response?.data?.data) {
        items = response.data.data
        pagination = response.data
      } else if (Array.isArray(response?.data)) {
        items = response.data
        pagination = response
      } else if (Array.isArray(response)) {
        items = response
        pagination = { total: response.length, per_page: response.length, current_page: 1, last_page: 1 }
      }
      
      commit('SET_ITEMS', items)
      commit('SET_PAGINATION', pagination)
      return { success: true }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في جلب البيانات'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPermissions({ commit }) {
    try {
      const response = await RolesService.getPermissions()
      // With _no_pagination_=1, data is in response.data
      const permissions = response?.data || []
      commit('SET_PERMISSIONS', permissions)
      return { success: true, data: permissions }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في جلب الصلاحيات'
      return { success: false, message }
    }
  },

  async fetchById({ commit }, id) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await RolesService.getById(id)
      commit('SET_CURRENT_ITEM', response.data)
      return { success: true, data: response.data }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في جلب البيانات'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async create({ commit, dispatch, state }, data) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await RolesService.create(data)
      const item = response?.data || response
      await dispatch('fetchAll', { page: state.pagination.page, perPage: state.pagination.perPage })
      return { success: true, message: response?.message || 'تم الإضافة بنجاح', data: item }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في الإضافة'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async update({ commit, dispatch, state }, { id, data }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await RolesService.update(id, data)
      const item = response?.data || response
      await dispatch('fetchAll', { page: state.pagination.page, perPage: state.pagination.perPage })
      return { success: true, message: response?.message || 'تم التحديث بنجاح', data: item }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في التحديث'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async delete({ commit, dispatch, state }, id) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      await RolesService.delete(id)
      await dispatch('fetchAll', { page: state.pagination.page, perPage: state.pagination.perPage })
      return { success: true, message: 'تم الحذف بنجاح' }
    } catch (error) {
      const message = error.response?.data?.message || 'فشل في الحذف'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
